/* eslint-disable */
// source: vivacity/config_v2/shared_metadata_class_configs.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.vivacity.config_v2.SharedMetadataClassConfig', null, global);
goog.exportSymbol('proto.vivacity.config_v2.SharedMetadataClassConfig.ClassType', null, global);
goog.exportSymbol('proto.vivacity.config_v2.SharedMetadataClassConfig.Type', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.config_v2.SharedMetadataClassConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vivacity.config_v2.SharedMetadataClassConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.config_v2.SharedMetadataClassConfig.displayName = 'proto.vivacity.config_v2.SharedMetadataClassConfig';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.config_v2.SharedMetadataClassConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.config_v2.SharedMetadataClassConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.config_v2.SharedMetadataClassConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.config_v2.SharedMetadataClassConfig.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.config_v2.SharedMetadataClassConfig}
 */
proto.vivacity.config_v2.SharedMetadataClassConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.config_v2.SharedMetadataClassConfig;
  return proto.vivacity.config_v2.SharedMetadataClassConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.config_v2.SharedMetadataClassConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.config_v2.SharedMetadataClassConfig}
 */
proto.vivacity.config_v2.SharedMetadataClassConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.config_v2.SharedMetadataClassConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.config_v2.SharedMetadataClassConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.config_v2.SharedMetadataClassConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.config_v2.SharedMetadataClassConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.vivacity.config_v2.SharedMetadataClassConfig.Type = {
  UNKNOWN_TYPE: 0,
  ENTITY: 1,
  RELATIONSHIP: 2
};

/**
 * @enum {number}
 */
proto.vivacity.config_v2.SharedMetadataClassConfig.ClassType = {
  UNKNOWN_CLASS_TYPE: 0,
  UNSUPPORTED_CLASS: 1,
  UNREFERENCED_STUB_CLASS: 2,
  TEST_PARENT_ENTITY: 100,
  TEST_CHILD_ENTITY: 101,
  TEST_REFERENCE_ENTITY: 102,
  TEST_PARENT_ENTITY_TO_TEST_REFERENCE_ENTITY: 103,
  HARDWARE: 1000,
  VISION_PROGRAM: 1001,
  HARDWARE_POSITION: 1002,
  VISION_PROGRAM_TO_CLASS: 1003,
  COUNTRY: 2000,
  REGION: 2001,
  CONTROLLER: 2002,
  CONTROLLER_STREAM: 2003,
  STAGE: 2004,
  PHASE: 2005,
  STAGE_TO_PHASE: 2006,
  ZONE_IMAGE_SPACE_TO_CLASS: 2007
};

goog.object.extend(exports, proto.vivacity.config_v2);
